import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

/**
 * Guard fonctionnel Angular 17+ : protège les routes authentifiées.
 * Vérifie que le JWT existe dans localStorage ET n'est pas expiré.
 * Si invalide → nettoie le storage et redirige vers /login.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  // Token absent ou expiré → nettoyage et redirection login ; la page demandée
  // est rouverte après la connexion (returnUrl).
  authService.logout();
  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};
